import React from 'react';
import Page, { Container, PageHeader, PageTitle } from 'components/Page';
import AudienceForm from './components/AudienceForm';

function CampaignAvailableAudience() {
  return (
    <Page>
      <PageHeader>
        <PageTitle>درخواست آمار کمپین تبلیغاتی جدید</PageTitle>
      </PageHeader>

      <Container>
        <AudienceForm />
      </Container>
    </Page>
  );
}

export default CampaignAvailableAudience;
